import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

export default ({ data }) => {
    const page = data.markdownRemark
    return (
        <Layout>
            <SEO title={page.frontmatter.title} />
            <div className="container">
                <h1 className="text-center mt-3">{page.frontmatter.title}</h1>
                <div class="row mt-3" >
                    <div class="col" dangerouslySetInnerHTML={{ __html: page.html }}/>
                </div>
            </div>
        </Layout>
    )
}

export const query = graphql`
    query($slug: String!) {
        markdownRemark(fields: { slug: { eq: $slug } }) {
        html
        frontmatter {
            title
            featuredImage {
                childImageSharp {
                    fluid(maxWidth: 1000) {
                        ...GatsbyImageSharpFluid_noBase64
                    }
                }
            }
        }
        }
    }
`